<template>
  <div class="mobile">
    <div class="container" id="containerMobile">
      <div class="section1">
        <img alt="xxx" :src="data.mobile.sec1Url" style="width: 100%;" />
      </div>
      <div class="section2-container" v-if="sec2Display">
        <div class="nav-wrap">
          <div class="nav">
            <div class="nav-show" v-if="sec2Arrow">
              <div class="item" v-if="navIndex==1" @click="changeNav(1)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23174641j51E.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(230,126,2,1);">传奇西域</div>
              </div>
              <div class="item" v-if="navIndex!=1" @click="changeNav(1)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23003800e9u5.png"
                    style="width: 100%;"
                  />
                </div>
                <div>传奇西域</div>
              </div>
              <div class="item" v-if="navIndex==2" @click="changeNav(2)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23174707YJ4f.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(53,114,171,1);">天空之镜</div>
              </div>
              <div class="item" v-if="navIndex!=2" @click="changeNav(2)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/2300442036ku.png"
                    style="width: 100%;"
                  />
                </div>
                <div>天空之镜</div>
              </div>
              <div class="item" v-if="navIndex==3" @click="changeNav(3)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23174745sX0E.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(255,205,66,1);">黄河明珠</div>
              </div>
              <div class="item" v-if="navIndex!=3" @click="changeNav(3)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23004442Ifd6.png"
                    style="width: 100%;"
                  />
                </div>
                <div>黄河明珠</div>
              </div>
              <div class="item" v-if="navIndex==4" @click="changeNav(4)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/231748068Oyk.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(238,34,0,1);">红色基地</div>
              </div>
              <div class="item" v-if="navIndex!=4" @click="changeNav(4)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/230045019O47.png"
                    style="width: 100%;"
                  />
                </div>
                <div>红色基地</div>
              </div>
            </div>
            <div class="nav-show" v-if="sec2Arrow==false">
              <div class="nav-line1" v-if="navIndex==1||navIndex==2||navIndex==3||navIndex==4">
                <div class="item" v-if="navIndex==1" @click="changeNav(1)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/23174641j51E.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div style="color:rgba(230,126,2,1);">传奇西域</div>
                </div>
                <div class="item" v-if="navIndex!=1" @click="changeNav(1)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/23003800e9u5.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div>传奇西域</div>
                </div>
                <div class="item" v-if="navIndex==2" @click="changeNav(2)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/23174707YJ4f.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div style="color:rgba(53,114,171,1);">天空之镜</div>
                </div>
                <div class="item" v-if="navIndex!=2" @click="changeNav(2)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/2300442036ku.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div>天空之镜</div>
                </div>
                <div class="item" v-if="navIndex==3" @click="changeNav(3)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/23174745sX0E.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div style="color:rgba(255,205,66,1);">黄河明珠</div>
                </div>
                <div class="item" v-if="navIndex!=3" @click="changeNav(3)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/23004442Ifd6.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div>黄河明珠</div>
                </div>
                <div class="item" v-if="navIndex==4" @click="changeNav(4)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/231748068Oyk.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div style="color:rgba(238,34,0,1);">红色基地</div>
                </div>
                <div class="item" v-if="navIndex!=4" @click="changeNav(4)">
                  <div class="img">
                    <img
                      alt="xxx"
                      src="https://www.csvw.com/u/cms/www/202008/230045019O47.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div>红色基地</div>
                </div>
              </div>
              <div class="nav-line2" v-if="navIndex==5||navIndex==6||navIndex==7||navIndex==8">
                <div class="nav-hidden">
                  <div class="item" v-if="navIndex==5" @click="changeNav(5)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/231748376L09.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(199,90,32,1);">千年古都</div>
                  </div>
                  <div class="item" v-if="navIndex!=5" @click="changeNav(5)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23005940KDo6.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>千年古都</div>
                  </div>
                  <div class="item" v-if="navIndex==6" @click="changeNav(6)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/2317485697h7.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(22, 160, 93, 1);">兴汉胜境</div>
                  </div>
                  <div class="item" v-if="navIndex!=6" @click="changeNav(6)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/2300591966Gh.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>兴汉胜境</div>
                  </div>
                  <div class="item" v-if="navIndex==7" @click="changeNav(7)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/231749190964.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(241,117,51, 1);">巴蜀韵味</div>
                  </div>
                  <div class="item" v-if="navIndex!=7" @click="changeNav(7)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23005903857b.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>巴蜀韵味</div>
                  </div>
                  <div class="item" v-if="navIndex==8" @click="changeNav(8)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/231749378045.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(82,94,74, 1);">民族风情</div>
                  </div>
                  <div class="item" v-if="navIndex!=8" @click="changeNav(8)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23005845Yu21.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>民族风情</div>
                  </div>
                </div>
              </div>
              <div class="nav-line3" v-if="navIndex==9||navIndex==10||navIndex==11||navIndex==12">
                <div class="nav-hidden">
                  <div class="item" v-if="navIndex==9" @click="changeNav(9)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/03173850g454.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(103,126,44, 1);">川西美景</div>
                  </div>
                  <div class="item" v-if="navIndex!=9" @click="changeNav(9)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23005817dYH7.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>川西美景</div>
                  </div>
                  <div class="item" v-if="navIndex==10" @click="changeNav(10)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/231839168v41.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(23,159,93, 1);">人间秘境</div>
                  </div>
                  <div class="item" v-if="navIndex!=10" @click="changeNav(10)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23005751Ed8W.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>人间秘境</div>
                  </div>
                  <div class="item" v-if="navIndex==11" @click="changeNav(11)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/23175143nSEH.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(58,82,170,1);">魔幻山城</div>
                  </div>
                  <div class="item" v-if="navIndex!=11" @click="changeNav(11)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202008/230057327Tr9.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>魔幻山城</div>
                  </div>
                  <div class="item" v-if="navIndex==12" @click="changeNav(12)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02142031UXp6.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(40,148,223,1);">楚汉名城</div>
                  </div>
                  <div class="item" v-if="navIndex!=12" @click="changeNav(12)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02142106QS4t.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>楚汉名城</div>
                  </div>
                </div>
              </div>
              <div class="nav-line4" v-if="navIndex==13||navIndex==14||navIndex==15">
                <div class="nav-hidden">
                  <div class="item" v-if="navIndex==13" @click="changeNav(13)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02141755TWkk.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(254,0,0,1);">英雄之城</div>
                  </div>
                  <div class="item" v-if="navIndex!=13" @click="changeNav(13)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/0214173993g3.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>英雄之城</div>
                  </div>
                  <div class="item" v-if="navIndex==14" @click="changeNav(14)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02141859469S.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(1,123,209,1);">荆楚风韵</div>
                  </div>
                  <div class="item" v-if="navIndex!=14" @click="changeNav(14)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/021418411cr4.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>荆楚风韵</div>
                  </div>
                  <div class="item" v-if="navIndex==15" @click="changeNav(15)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02144729W36S.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div style="color:rgba(210,174,98,1);">邂逅金陵</div>
                  </div>
                  <div class="item" v-if="navIndex!=15" @click="changeNav(15)">
                    <div class="img">
                      <img
                        alt="xxx"
                        src="https://www.csvw.com/u/cms/www/202009/02144744Oeb1.png"
                        style="width: 100%;"
                      />
                    </div>
                    <div>邂逅金陵</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="arrow">
              <div class="img" v-if="sec2Arrow" @click="changeSec2Arrow(1)">
                <img alt="xxx" src="../../assets/imgs/up2.png" style="width: 100%;" />
              </div>
              <div class="img" v-if="sec2Arrow==false" @click="changeSec2Arrow(2)">
                <img alt="xxx" src="../../assets/imgs/down2.png" style="width: 100%;" />
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="nav-hidden" v-if="sec2Arrow">
              <div class="item" v-if="navIndex==5" @click="changeNav(5)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/231748376L09.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(199,90,32,1);">千年古都</div>
              </div>
              <div class="item" v-if="navIndex!=5" @click="changeNav(5)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23005940KDo6.png"
                    style="width: 100%;"
                  />
                </div>
                <div>千年古都</div>
              </div>
              <div class="item" v-if="navIndex==6" @click="changeNav(6)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/2317485697h7.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(22, 160, 93, 1);">兴汉胜境</div>
              </div>
              <div class="item" v-if="navIndex!=6" @click="changeNav(6)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/2300591966Gh.png"
                    style="width: 100%;"
                  />
                </div>
                <div>兴汉胜境</div>
              </div>
              <div class="item" v-if="navIndex==7" @click="changeNav(7)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/231749190964.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(241,117,51, 1);">巴蜀韵味</div>
              </div>
              <div class="item" v-if="navIndex!=7" @click="changeNav(7)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23005903857b.png"
                    style="width: 100%;"
                  />
                </div>
                <div>巴蜀韵味</div>
              </div>
              <div class="item" v-if="navIndex==8" @click="changeNav(8)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/231749378045.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(82,94,74, 1);">民族风情</div>
              </div>
              <div class="item" v-if="navIndex!=8" @click="changeNav(8)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23005845Yu21.png"
                    style="width: 100%;"
                  />
                </div>
                <div>民族风情</div>
              </div>
              <div style="clear: both;"></div>
            </div>
            <div class="nav-hidden" v-if="sec2Arrow">
              <div class="item" v-if="navIndex==9" @click="changeNav(9)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/03173850g454.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(103,126,44, 1);">川西美景</div>
              </div>
              <div class="item" v-if="navIndex!=9" @click="changeNav(9)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23005817dYH7.png"
                    style="width: 100%;"
                  />
                </div>
                <div>川西美景</div>
              </div>
              <div class="item" v-if="navIndex==10" @click="changeNav(10)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/231839168v41.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(23,159,93, 1);">人间秘境</div>
              </div>
              <div class="item" v-if="navIndex!=10" @click="changeNav(10)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23005751Ed8W.png"
                    style="width: 100%;"
                  />
                </div>
                <div>人间秘境</div>
              </div>
              <div class="item" v-if="navIndex==11" @click="changeNav(11)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/23175143nSEH.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(58,82,170,1);">魔幻山城</div>
              </div>
              <div class="item" v-if="navIndex!=11" @click="changeNav(11)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/230057327Tr9.png"
                    style="width: 100%;"
                  />
                </div>
                <div>魔幻山城</div>
              </div>
              <div class="item" v-if="navIndex==12" @click="changeNav(12)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02142031UXp6.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(40,148,223,1);">楚汉名城</div>
              </div>
              <div class="item" v-if="navIndex!=12" @click="changeNav(12)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02142106QS4t.png"
                    style="width: 100%;"
                  />
                </div>
                <div>楚汉名城</div>
              </div>

              <div style="clear: both;"></div>
            </div>
            <div class="nav-hidden" v-if="sec2Arrow">
              <div class="item" v-if="navIndex==13" @click="changeNav(13)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02141755TWkk.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(254,0,0,1);">英雄之城</div>
              </div>
              <div class="item" v-if="navIndex!=13" @click="changeNav(13)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/0214173993g3.png"
                    style="width: 100%;"
                  />
                </div>
                <div>英雄之城</div>
              </div>
              <div class="item" v-if="navIndex==14" @click="changeNav(14)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02141859469S.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(1,123,209,1);">荆楚风韵</div>
              </div>
              <div class="item" v-if="navIndex!=14" @click="changeNav(14)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/021418411cr4.png"
                    style="width: 100%;"
                  />
                </div>
                <div>荆楚风韵</div>
              </div>
              <div class="item" v-if="navIndex==15" @click="changeNav(15)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02144729W36S.png"
                    style="width: 100%;"
                  />
                </div>
                <div style="color:rgba(210,174,98,1);">邂逅金陵</div>
              </div>
              <div class="item" v-if="navIndex!=15" @click="changeNav(15)">
                <div class="img">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202009/02144744Oeb1.png"
                    style="width: 100%;"
                  />
                </div>
                <div>邂逅金陵</div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div class="section2" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <div class="contain">
            <img alt="xxx" :src="data.mobile.sec2Kv" style="width: 100%;" />
            <div class="text">{{data.sec2.text}}</div>
            <img alt="xxx" :src="data.mobile.sec2MapUrl" style="width: 100%;margin-top:10px;" />
          </div>
        </div>
        <div class="section3" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <div class="title">
            <img alt="xxx" :src="data.mobile.sec3Title" style="width: 100%;" />
          </div>
          <div class="contain">
            <!-- <swiperSec3Mobile :data="data.mobile"></swiperSec3Mobile> -->
            <div class="left">
              <img alt="xxx" :src="sec3Img1" style="width: 100%;" @click="sec3ChangeLeft()" />
            </div>
            <div class="middle">
              <img alt="xxx" :src="sec3Img2" style="width: 100%;" @click="showPop(sec3Img2)" />
            </div>
            <div class="right">
              <img alt="xxx" :src="sec3Img3" style="width: 100%;" @click="sec3ChangeRight()" />
            </div>
            <div class="click-left" @click="sec3ChangeLeft()">
              <img alt="xxx" src="../../assets/imgs/left-white.png" style="width: 100%;" />
            </div>
            <div class="click-right" @click="sec3ChangeRight()">
              <img alt="xxx" src="../../assets/imgs/right-white.png" style="width: 100%;" />
            </div>
          </div>
        </div>
        <div class="section4" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <img alt="xxx" :src="data.mobile.sec4Title" style="width: 100%;" />
          <div class="contain">
            <div v-if="videoType==0" @click="changeVideoType()" class="clickStyle">
              <img alt="xxx" :src="data.sec3.videoImg" style="width: 100%;height:180px;" />
            </div>
            <div v-if="videoType==1">
              <video class="video" muted autoplay="autoplay" loop="loop" controls="controls">
                <source :src="data.sec3.videoUrl" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
        <div class="section5" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <div class="title">
            <img alt="xxx" :src="data.mobile.sec5Title" style="width: 100%;" />
          </div>
          <div class="contain">
            <div class="item" v-for="(item ,i) in data.sec3.list" :key="i">
              <div class="title">{{item.title}}</div>
              <div class="content">
                <div class="left" v-if="item.img1!='https://www.csvw.com'">
                  <img
                    alt="xxx"
                    :src="item.img1"
                    style="width: 100%;"
                    @click="showPopSingle(item.img1Pop)"
                    class="clickStyle"
                  />
                </div>
                <div class="right" v-if="item.img2!='https://www.csvw.com'">
                  <img
                    alt="xxx"
                    :src="item.img2"
                    style="width: 100%;"
                    @click="showPopSingle(item.img2Pop)"
                    class="clickStyle"
                  />
                </div>
                <div style="clear: both;"></div>
              </div>
              <div class="text">{{item.text}}</div>
            </div>
          </div>
        </div>
        <div class="section6" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <div class="title">
            <img alt="xxx" :src="data.mobile.sec6Title" style="width: 100%;" />
          </div>
          <div class="contain">
            <div class="nav">
              <div style="clear: both;"></div>
              <img alt="xxx" :src="sec3NavImg" style="width: 100%;" />
              <div class="left clickStyle" id="contain3Nav1" @click="changeSec6Img(1)"></div>
              <div class="right clickStyle" id="contain3Nav2" @click="changeSec6Img(2)"></div>
            </div>
            <div style="clear: both;"></div>
            <div class="img">
              <img alt="xxx" :src="sec3Contain3Img" style="width: 100%;" />
            </div>
            <div class="text">{{sec3Contain3Text}}</div>
          </div>
        </div>
        <div class="section7" @click="changeSec2Arrow(1)" @touchstart="changeSec2Arrow(1)">
          <img alt="xxx" :src="data.mobile.sec7Bck" style="width: 100%;" />
        </div>
      </div>

      <div class="section8">
        <popupMobile
          :showCover="showCover"
          :popUrl="popUrl"
          :dataPop="dataPop"
          :closePop="closePop"
        ></popupMobile>
        <popupSingleMobile
          :showCover="showCoverSingle"
          :closePop="closePopSingle"
          :popUrl="popUrlSingle"
        ></popupSingleMobile>
      </div>
    </div>
  </div>
</template>
<script>
import swiperSec3Mobile from "../../components/swiper/phev/swiperSec3Mobile.vue";
import popupMobile from "../../components/popup/phev/popupMobile";
import popupSingleMobile from "../../components/popup/phev/popupSingleMobile";

import {
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  data8,
  data9,
  data10,
  data11,
  data12,
  data13,
  data14,
  data15,
} from "./data";
import { pbev_306, pbev_308 } from "../../components/config";

export default {
  name: "phevMobile",
  components: {
    swiperSec3Mobile,
    popupMobile,
    popupSingleMobile,
  },
  data() {
    return {
      navIndex: 1, // 第几个主题
      videoType: 0,
      showCover: false,
      showCoverSingle: false,
      popUrl: "",
      popUrlSingle: "",
      sec2Display: true,
      sec2Arrow: false,
      sec3Index: 0,
      sec3Img1: "",
      sec3Img2: "",
      sec3Img3: "",
      sec3NavImg: "",
      sec3Contain3Text: "",
      sec3Contain3Text1:
        "帕萨特插电式混合动力版最大功率155kW，最大扭矩400Nm，混合动力模式百公里加速7.8s，纯电模式续航里程63km。更有多种驾驶模式解决各种用车路况需求，以先进的双擎动力科技、强劲又不失平顺的驾控体验、令人放心的安全防护，成为PHEV细分市场的破局者。",
      sec3Contain3Text2:
        "途观L插电式混合动力版承袭途观出众的产品基因背书，汇集大众领先的新能源技术，凭借卓越的混合动力系统、全方位的安全技术、大众最新智电科技及大气独特的外观设计，打造“放心使用的PHEV”，为追求品质又注重节能的消费者提供新的选择。途观L插电式混合动力版的到来填补了新能源市场合资品牌PHEV车型空缺，以市场破局者之姿，树立PHEV市场安全新标杆。",
      sec3Contain3Img: pbev_306,
      data: data1,
      dataPop: [
        {
          index: 0,
          url: "",
        },
      ], // 弹出框图片
    };
  },
  mounted: function () {
    this.changeNav(1);
    this.changeSec6Img(1);
    this.changeDataPop();
  },
  methods: {
    changeSec2Arrow(type) {
      if (type == 1) {
        this.sec2Arrow = false;
      } else {
        this.sec2Arrow = true;
      }
    },
    changeNav(type) {
      this.navIndex = type;
      if (type == 1) {
        this.data = data1;
        document.getElementById(`containerMobile`).style.background =
          "rgba(243,234,225,1)";
      } else if (type == 2) {
        this.data = data2;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251,1)";
      } else if (type == 3) {
        this.data = data3;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239,1)";
      } else if (type == 4) {
        this.data = data4;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239,1)";
      } else if (type == 5) {
        this.data = data5;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239,1)";
      } else if (type == 6) {
        this.data = data6;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 7) {
        this.data = data7;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239, 1)";
      } else if (type == 8) {
        this.data = data8;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 9) {
        this.data = data9;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 10) {
        this.data = data10;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 11) {
        this.data = data11;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 12) {
        this.data = data12;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 13) {
        this.data = data13;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239, 1)";
      } else if (type == 14) {
        this.data = data14;
        document.getElementById(`containerMobile`).style.background =
          "rgba(251,251,251, 1)";
      } else if (type == 15) {
        this.data = data15;
        document.getElementById(`containerMobile`).style.background =
          "rgba(247,244,239, 1)";
      }

      this.videoType = 0; // 视频给关了
      this.changeDataPop();
      this.changeSec6Img(1);
    },
    changeDataPop() {
      const data = [];
      const obj = {};
      const { img2Pop, img3Pop, img4Pop } = this.data.sec2;
      data.push({ index: 0, url: img2Pop });
      data.push({ index: 1, url: img3Pop });
      data.push({ index: 2, url: img4Pop });
      let inde = 2;
      const list = this.data.sec3.list;
      for (let item of list) {
        inde++;
        data.push({ index: inde, url: item.img1Pop });
        inde++;
        data.push({ index: inde, url: item.img2Pop });
      }
      this.dataPop = data;
      this.sec3Img1 = this.dataPop[0].url;
      this.sec3Img2 = this.dataPop[1].url;
      this.sec3Img3 = this.dataPop[2].url;
    },
    sec3ChangeLeft(e) {
      if (this.sec3Index >= 1) {
        this.sec3Index--;
      }
      this.sec3Img1 = this.dataPop[this.sec3Index].url;
      this.sec3Img2 = this.dataPop[this.sec3Index + 1].url;
      this.sec3Img3 = this.dataPop[this.sec3Index + 2].url;
      e = e || window.event;
      if (e.stopPropagation) {
        //W3C阻止冒泡方法 e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    sec3ChangeRight(e) {
      this.sec3Index++;
      if (this.sec3Index > this.dataPop.length - 2) {
        for (let index in this.dataPop) {
          this.dataPop.push(this.dataPop[index]);
        }
      }
      this.sec3Img1 = this.dataPop[this.sec3Index].url;
      this.sec3Img2 = this.dataPop[this.sec3Index + 1].url;
      this.sec3Img3 = this.dataPop[this.sec3Index + 2].url;
      e = e || window.event;
      if (e.stopPropagation) {
        //W3C阻止冒泡方法 e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    changeVideoType() {
      this.videoType = 1;
    },
    changeSec6Img(index) {
      if (index == 1) {
        this.sec3Contain3Text = this.sec3Contain3Text1;
        this.sec3Contain3Img = pbev_306;
        this.sec3NavImg = this.data.mobile.sec6NavLeft;
      } else if (index == 2) {
        this.sec3Contain3Text = this.sec3Contain3Text2;
        this.sec3Contain3Img = pbev_308;
        this.sec3NavImg = this.data.mobile.sec6NavRight;
      }
    },
    showPop(url) {
      this.showCover = true;
      this.popUrl = url;
      this.sec2Display = false;
    },
    closePop() {
      this.showCover = false;
      this.sec2Display = true;
      this.sec2Arrow = false;
    },
    showPopSingle(url) {
      this.showCoverSingle = true;
      this.popUrlSingle = url;
      this.sec2Display = false;
    },
    closePopSingle() {
      this.showCoverSingle = false;
      this.sec2Display = true;
      this.sec2Arrow = false;
    },
  },
};
</script>

<style scoped>
.clickStyle {
  cursor: pointer;
}
.container {
  background: #f3eae1;
}
.container img {
  display: block;
}
.section1 {
  position: relative;
  margin-top: 20px;
}

.section2-container {
  position: relative;
  width: 100%;
}
.section2 {
  position: relative;
  padding: 0px 15px;
}
.nav-wrap {
  position: sticky;
  top: 140px;
  z-index: 9;
}
.nav-wrap .nav {
  position: absolute;
  width: 83%;
  margin: auto;
  left: 0;
  right: 0;
  top: -80px;
  padding: 0px 15px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  z-index: 100;
}
.nav-wrap .nav-hidden {
  z-index: 100;
}
.nav-wrap .nav .item {
  position: relative;
  float: left;
  width: 22%;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.nav-wrap .nav .item .img {
  padding-left: 15px;
  padding-right: 15px;
}
.nav-wrap .nav .arrow {
  position: relative;
  float: right;
  width: 20px;
  height: 66px;
}
.nav-wrap .nav .arrow .img {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.section2 .contain {
  position: relative;
  padding: 15px 15px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 1);
}
.section2 .contain .text {
  margin-top: 10px;
  font-size: 14px;
  color: rgba(33, 33, 33, 1);
  line-height: 24px;
}
.section3 {
  position: relative;
  padding: 15px 15px;
  padding-bottom: 18px;
  padding-top: 18px;
}
.section3 .title {
  position: relative;
  width: 120px;
  left: 50%;
  margin-left: -60px;
}
.section3 .contain {
  position: relative;
  margin-top: 18px;
  width: 100%;
  height: 130px;
}
.section3 .contain .left {
  position: absolute;
  width: 200px;

  top: 0;
  bottom: 0;
  left: 0px;
  margin: auto;
  transform: scaleY(0.7);
}
.section3 .contain .middle {
  position: absolute;
  width: 200px;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 8;
}
.section3 .contain .right {
  position: absolute;
  width: 200px;
  top: 0;
  bottom: 0;
  right: 0px;
  margin: auto;
  transform: scaleY(0.7);
}
.section3 .contain .click-left {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  left: 10px;
  margin-top: -10px;
}
.section3 .contain .click-right {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  right: 10px;
  margin-top: -10px;
}
.section4 {
  position: relative;
  padding: 0px 15px;
}
.section4 .contain {
  position: relative;
  padding: 0px 15px;
  margin-top: -200px;
}
.section4 .contain .video {
  width: 100%;
  height: 180px;
}
.section5 {
  position: relative;
  padding: 0px 15px;
  margin-top: 40px;
}
.section5 .contain {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 0px 15px;
}
.section5 .contain .item {
  position: relative;
  padding-top: 25px;
}
.section5 .contain .item .title {
  position: relative;
  font-size: 16px;
  color: rgba(33, 33, 33, 1);
}
.section5 .contain .item .text {
  position: relative;
  font-size: 14px;
  color: rgba(119, 119, 119, 1);
  line-height: 24px;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: solid 1px rgba(190, 190, 190, 1);
}
.section5 .contain .item .content {
  position: relative;
  width: 100%;
  margin-top: 25px;
}
.section5 .contain .item .content .left {
  position: relative;
  float: left;
  width: 49%;
}
.section5 .contain .item .content .right {
  position: relative;
  float: right;
  width: 49%;
}
.section6 {
  position: relative;
  padding: 0px 15px;
  margin-top: 20px;
}
.section6 .title {
  position: relative;
  width: 120px;
  left: 50%;
  margin-left: -60px;
}
.section6 .contain {
  position: relative;
  background: rgba(255, 255, 255, 1);
  margin-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;
}
.section6 .contain .nav {
  position: relative;
  width: 100%;
}
.section6 .contain .nav .left {
  position: absolute;
  width: 50%;
  height: 50px;
  top: 0;
  left: 0;
  -webkit-tap-highlight-color: transparent;
}
.section6 .contain .nav .right {
  position: absolute;
  width: 50%;
  height: 50px;
  top: 0;
  left: 50%;
  -webkit-tap-highlight-color: transparent;
}
.section6 .contain .img {
  margin: 15px 15px;
}
.section6 .contain .text {
  margin: 15px 15px;
  font-size: 14px;
  color: rgba(119, 119, 119, 1);
  line-height: 24px;
}
</style>